import styled from 'styled-components'


export const TreeViewCustome=styled.div`
    width: "100%" !important;
    height:"100%" !important;
    & .rd3t-link{
        stroke: ${props=>props.color} !important;
    };
`